import { ChassisSeriesTypes } from "./ChassisType";

export default interface MetaData {
    attributes: CompanyAttributes
}

export interface CompanyAttributes {
    dealerId?: string,
    companyName: string,
    active: boolean,
    international?: boolean,
    customVehiclePricing?: boolean,
    freightChargesDisabled?: boolean,
    dateCreated?: string,
    logo?: string,
    priorityDealer?: boolean,
    allowLeads?: boolean,
    allowLeadsBySeriesType?: ChassisSeriesTypes[],
    licenses?: License[],
    inStoreSignageSkusOrdered?: string[]
}

export interface License {
    status: LicenseStatusType,
    stateCode: string,
    state: string,
    type: LicenseType,
    expirationDate: string,
  }

  export const LicenseTypes = ['LSV', 'Recreational'] as const;

  export type LicenseType = typeof LicenseTypes[number];

  export const LicenseStatusTypes = ['active', 'inactive'] as const;

  export type LicenseStatusType = typeof LicenseStatusTypes[number];
